
<template>
	<div class="h-screen flex w-full bg-img"> 
	</div>
	
</template>

<script>  
import { logoutUser } from '@/utils/index';

export default {
	data() {
		return { 
			checkBox1: false
		}
	},
	methods: { 
		logout() {
			logoutUser(true);
		}
	},
	mounted() {
		this.logout();
	}

}
</script>
